import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface SnackMessageData {
  type: 'success' | 'error' | string;
  title: string;
  message: string;
}

/** Toast content used with MatSnackBar.openFromComponent. Port of legacy SnackMessageComponent. */
@Component({
  selector: 'app-snack-message',
  templateUrl: './snack-message.component.html',
  styleUrl: './snack-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackMessageComponent {
  readonly snackBarRef = inject<MatSnackBarRef<SnackMessageComponent>>(MatSnackBarRef);
  readonly data = inject<SnackMessageData>(MAT_SNACK_BAR_DATA);

  readonly config = computed(() => {
    const type = this.data.type;
    if (type === 'success') {
      return { color: '#43A047', iconLeft: 'assets/icons/icon-aprobation.png' };
    } else if (type === 'error') {
      return { color: '#F44336', iconLeft: 'assets/icons/icon-exclamation.png' };
    }
    return { color: '', iconLeft: '' };
  });
}
